module.exports = __webpack_public_path__ + "static/media/Alexandra_Garduno_Avila.3fbb434d.png";